import {Card} from 'antd';
import React, {Component} from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import QueryAndMutationForStarterpack, {QueryAndMutationForStarterpackObject} from './components/QueryMutation';
import StarterpackDetail from './components/StarterpackDetail';
import './styles.css';

interface Properties extends RouteComponentProps {
  regionId: string;
  clubId: string;
  externalStarterPackId: string;
}

class StarterpackDetailWrap extends Component<Properties> {
  render() {
    return (
      <QueryAndMutationForStarterpack {...this.props}>
        {({starterpackData, starterpacks, clubLanguages, updateStarterpack}: QueryAndMutationForStarterpackObject) => {
          const {starterpack, club, region} = starterpackData;
          const {languages} = clubLanguages;
          const error = starterpackData.error || clubLanguages.error;
          const loading = starterpackData.loading || clubLanguages.loading || starterpacks.loading;

          if (loading) {
            return <Card loading={loading} />;
          }

          if (error) {
            return `Error! ${error.message}`;
          }

          if (!starterpack) {
            this.props.history.push('/error');
            return <div />;
          }

          const starterPackPrice: any =
            starterpacks &&
            starterpacks.starterpacks &&
            starterpacks.starterpacks.find((sp: any) => sp.externalStarterPackId === starterpack.externalStarterPackId);

          const defaultStarterPack: any =
            starterpacks && starterpacks.starterpacks && starterpacks.starterpacks.find(m => Boolean(m.isDefault));
          const isDefaultMembershipExist: any = Boolean(defaultStarterPack) && defaultStarterPack.id !== starterpack.id;
          const isDefaultSelected = Boolean(defaultStarterPack) && isDefaultMembershipExist;

          return (
            <StarterpackDetail
              starterpack={starterpack}
              price={starterPackPrice}
              club={club}
              region={region}
              languages={languages}
              isDefaultSelected={isDefaultSelected}
              updateStarterpack={updateStarterpack}
            />
          );
        }}
      </QueryAndMutationForStarterpack>
    );
  }
}

export default withRouter(StarterpackDetailWrap);



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackDetail/StarterpackDetailWrap.tsx